module.exports = __webpack_public_path__ + "media/images/features/modification/heading-comparison-4421878a3c941f4b187f8f2c37647b5d.svg";